var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayoutGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "#1957E8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout-grid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 4.58329C3.66667 4.34018 3.76325 4.10702 3.93516 3.93511C4.10707 3.7632 4.34022 3.66663 4.58334 3.66663H8.25001C8.49312 3.66663 8.72628 3.7632 8.89819 3.93511C9.07009 4.10702 9.16667 4.34018 9.16667 4.58329V8.24996C9.16667 8.49307 9.07009 8.72623 8.89819 8.89814C8.72628 9.07005 8.49312 9.16663 8.25001 9.16663H4.58334C4.34022 9.16663 4.10707 9.07005 3.93516 8.89814C3.76325 8.72623 3.66667 8.49307 3.66667 8.24996V4.58329Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 4.58329C12.8333 4.34018 12.9299 4.10702 13.1018 3.93511C13.2737 3.7632 13.5069 3.66663 13.75 3.66663H17.4167C17.6598 3.66663 17.8929 3.7632 18.0649 3.93511C18.2368 4.10702 18.3333 4.34018 18.3333 4.58329V8.24996C18.3333 8.49307 18.2368 8.72623 18.0649 8.89814C17.8929 9.07005 17.6598 9.16663 17.4167 9.16663H13.75C13.5069 9.16663 13.2737 9.07005 13.1018 8.89814C12.9299 8.72623 12.8333 8.49307 12.8333 8.24996V4.58329Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 13.75C3.66667 13.5068 3.76325 13.2737 3.93516 13.1018C4.10707 12.9299 4.34022 12.8333 4.58334 12.8333H8.25001C8.49312 12.8333 8.72628 12.9299 8.89819 13.1018C9.07009 13.2737 9.16667 13.5068 9.16667 13.75V17.4166C9.16667 17.6597 9.07009 17.8929 8.89819 18.0648C8.72628 18.2367 8.49312 18.3333 8.25001 18.3333H4.58334C4.34022 18.3333 4.10707 18.2367 3.93516 18.0648C3.76325 17.8929 3.66667 17.6597 3.66667 17.4166V13.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 13.75C12.8333 13.5068 12.9299 13.2737 13.1018 13.1018C13.2737 12.9299 13.5069 12.8333 13.75 12.8333H17.4167C17.6598 12.8333 17.8929 12.9299 18.0649 13.1018C18.2368 13.2737 18.3333 13.5068 18.3333 13.75V17.4166C18.3333 17.6597 18.2368 17.8929 18.0649 18.0648C17.8929 18.2367 17.6598 18.3333 17.4167 18.3333H13.75C13.5069 18.3333 13.2737 18.2367 13.1018 18.0648C12.9299 17.8929 12.8333 17.6597 12.8333 17.4166V13.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutGrid);
export default __webpack_public_path__ + "static/media/layout-grid.e047811f3e3a2820bc9665eeb9f60109.svg";
export { ForwardRef as ReactComponent };